import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { getRequest } from "../../../service";
import { formatDate } from "../../../utils/dateTime";

const LeaveHistory = ({ employeeId }) => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaveRequests = async () => {
      try {
        setLoading(true);
        const response = await getRequest(`/api/leaveRequest?employeeId=${employeeId}&onlyMe=true`);
        if (response.leaveRequests) {
          setLeaveRequests(response.leaveRequests);
        }
      } catch (error) {
        console.error("Error fetching leave requests:", error);
      } finally {
        setLoading(false);
      }
    };

    if (employeeId) {
      fetchLeaveRequests();
    }
  }, [employeeId]);

  const formatDate = (dateString) => {
    return formatDate(dateString);
  };

  const formatDuration = (startDate, endDate, leaveDuration, leaveDays) => {
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    
    if (start === end) {
      return `${start} (${leaveDuration === 'half' ? 'Half Day' : 'Full Day'})`;
    }
    return `${start} to ${end}`;
  };

  const columns = [
    {
      title: "Sr",
      dataIndex: "sr",
      key: "sr",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Leave Type",
      dataIndex: "leaveTypeName",
      key: "leaveTypeName",
      responsive: ["xs"],
    },
    {
      title: "Duration",
      key: "duration",
      responsive: ["sm"],
      render: (_, record) => formatDuration(
        record.startDate, 
        record.endDate, 
        record.leaveDuration, 
        record.leaveDays
      ),
    },
    {
      title: "Total days/hrs",
      dataIndex: "leaveDays",
      key: "leaveDays",
      responsive: ["md"],
      render: (leaveDays) => `${leaveDays} ${leaveDays === 1 ? 'day' : 'days'}`,
    },

  ];

  return (
    <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-md">
      <Table 
        columns={columns} 
        dataSource={leaveRequests}
        pagination={false}
        loading={loading}
        locale={{ emptyText: "No record found" }}
        scroll={{ x: true }}
        rowKey="_id"
      />
    </div>
  );
};

export default LeaveHistory;
